'use strict';

var React = require('react'),
    _ = require('underscore'),
    Analytics = require('../utils/Analytics'),
    AnalyticsEvents = require('../constants/AnalyticsEvents'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Button = require('../atoms/Button'),
    Link = require('../atoms/Link'),
    Icon = require('../atoms/Icon'),
    BtnGroup = require('../molecules/BtnGroup'),
    ServiceTypes = require('../constants/ServiceTypes'),
    PopupManager = require('../utils/PopupManager'),
    ModalActionCreators = require('../actions/ModalActionCreators'),
    ModalTypes = require('../constants/ModalTypes'),
    UserActionCreators = require('../actions/UserActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('./ShortSignUp.less');

var ShortLogin = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    color: React.PropTypes.oneOf(['light', 'gray']),
    size: React.PropTypes.oneOf(['small', 'medium', 'large']),
    source: React.PropTypes.oneOf(_.values(AnalyticsSources))
  },

  className: 'ShortSignUp',

  getDefaultProps: function () {
    return {
      size: 'large',
      color: 'gray'
    };
  },

  getCSSModifiers: function () {
    return [this.props.color];
  },

  render: function () {
    return (
      <div className={this.getClassName()}>
        <BtnGroup vertical>
          <Button size={this.props.size}
                  color='facebook'
                  onClick={this.handleFacebookClick}
                  fullWidth
                  fill>
            <Icon name='facebook' />
            Log In with Facebook
          </Button>
        </BtnGroup>

        <div className='ShortSignUp-moreOptions'>
          <Link onClick={this.handleMoreClick}
                color={this.props.color}
                underline='never'
                opaque>
            Show more options
          </Link>
        </div>
      </div>
    );
  },

  handleFacebookClick() {
    UserActionCreators.loginWithServiceAccount(ServiceTypes.FACEBOOK);
  },

  handleMoreClick() {
    ModalActionCreators.showModal(ModalTypes.LOGIN, {
      showComplementaryButtons: true,
      source: this.props.source
    });
  }
});

module.exports = ShortLogin;



/** WEBPACK FOOTER **
 ** ./molecules/ShortLogin.jsx
 **/